module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("2sYHg"))).then(() => parcelRequire('e6eQQ'));